export function createClientId(prefix = "id") {
  const cryptoApi = typeof window !== "undefined" ? window.crypto : null;

  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now().toString(36)}_${rand}`;
}
